import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import csCommon from './locales/cs/common.json';
import itCommon from './locales/it/common.json';
import enCommon from './locales/en/common.json';

void i18next.use(initReactI18next).init({
  resources: {
    cs: { common: csCommon },
    it: { common: itCommon },
    en: { common: enCommon },
  },
  lng: 'cs',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export const i18n = i18next;
